export class Controller {

    /** @ngInject */
    constructor(AccountsResource) {
        this.AccountsResource = AccountsResource;
    }

    $onInit() {
    }

    remove() {
        this.isSaving = true;
        this.AccountsResource
            .removeUsersFromGroup(
                this.resolve.companyId,
                this.resolve.groupId,
                this.resolve.accountIds,
            )
            .then(() => this.close())
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/remove/remove-accounts-from-group.controller.js